/**
 * Las secciones de sugerencias del buscador: las comparten el desplegable de texto
 * (`app-search`) y la ventana de búsqueda por voz (`app-busqueda-voz`), que piden los
 * mismos `search/<endpoint>` a la API.
 */
export const ENDPOINTS = ['categories', 'deals', 'stores', 'users'] as const;
export type Endpoint = (typeof ENDPOINTS)[number];

export interface Sugerencia {
  results: any[];
  total: number;
  loading: boolean;
}

export const SUGERENCIAS_VACIAS = () =>
  Object.fromEntries(ENDPOINTS.map(e => [e, { results: [], total: 0, loading: false }])) as Record<Endpoint, Sugerencia>;
